// Icon registry for Resource categories.
// Categories themselves come from the backend (/api/resource-categories) and
// are fully admin-editable. Each category stores an `icon` string that maps
// to one of the lucide-react components below.
import {
  FileText, Phone, Mail, Megaphone, BookOpen, Wrench, DollarSign,
  ClipboardList, Briefcase, Home, Users, Target, Sparkles, Handshake,
  Calculator, Map,
} from "lucide-react";

// Keep in sync with RESOURCE_CATEGORY_ICONS in /app/backend/models.py.
export const RESOURCE_CATEGORY_ICONS = {
  FileText, Phone, Mail, Megaphone, BookOpen, Wrench, DollarSign,
  ClipboardList, Briefcase, Home, Users, Target, Sparkles, Handshake,
  Calculator, Map,
};

export const RESOURCE_CATEGORY_ICON_NAMES = Object.keys(RESOURCE_CATEGORY_ICONS);

export function iconForCategory(name) {
  return RESOURCE_CATEGORY_ICONS[name] || FileText;
}
